var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRLetter = function SvgRLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 123 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r-letter_svg__a)",
    d: "M34.349 121.12c0 9.917-4.969 14.88-14.895 14.88H.382V0H59.68c17.26 0 30.36 4.403 39.327 13.199 8.955 8.796 13.442 20.493 13.442 35.063 0 19.173-8.594 32.331-25.793 39.466l36.05 48.262h-29.79c-7.813 0-13.803-3.082-17.98-9.256l-23.61-33.843H34.35v28.229Zm0-55.156h26.604c4.718 0 8.855-1.621 12.4-4.854 3.547-3.232 5.31-7.514 5.31-12.838s-1.743-9.947-5.22-13.159c-3.485-3.202-7.642-4.813-12.49-4.813H34.349z",
    className: "r-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "r-letter_svg__a",
    x1: -269.499,
    x2: 700.256,
    y1: 27.348,
    y2: 157.903,
    className: "r-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgRLetter;